<template>
    <div>
        <div class="column-layout">
            <div class="table-layout">
                <el-table ref="multipleTable" :data="xMsgList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column prop="txt" label="主题" show-overflow-tooltip></el-table-column>
                    <el-table-column label="内容" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.data != null && rows.row.data.indexOf('{') >= 0">{{ JSON.decode(rows.row.data).message }}</span>
                            <span v-else>{{rows.row.data}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="senderName" label="发信人名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="sendTime" width="200" label="发送时间" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="caozuo" width="80" label="操作" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click="msgInfo(rows.row)">查看</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- <div class="block pagination-layout">
                 <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
             </div>-->
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import userApi from '../../api/user';

    import merchtAllApi from '../../api/merchtAll'

    export default{
        name: 'swb-merchant-msg',
        desc: '商户信息',
        props: {
            type: {
                type: Number
            },
            source: {
                type: String
            },
            group: {
                type: String
            },
            fieldx: {
                type: String
            },
            fieldy: {
                type: String
            }
        },
        data: function () {
            return {
                xMsgList: []
            }
        },
        created: function () {
            this.getXMsgList();
        },
        methods: {
            /* handleSizeChange: function (val) {
             this.pageSize = val;
             this.handlePageChange(1);
             },
             handlePageChange: function (val) {
             this.pageNumber = val;
             this.getXMsgList();
             },*/
            getXMsgList: function () {
                let self = this;
                let postData = {};

                postData.source = self.source;
                postData.group = self.group;
                postData.fieldx = self.fieldx;
                postData.fieldy = self.fieldy;

                merchtAllApi.fetchSiteMsgList(postData, function (result) {
                    if(result.type == 'info') {
                        self.xMsgList = result.data;
                        /*self.totalCount = result.data.pagination.totalCount;*/
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            msgInfo: function (row) {
                Vue.$showDialog({
                    title: '查看站内信',
                    showCloseBtn: true,
                    height: 600,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>主题</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-input v-model="txt"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>内容</label>' +
                    '</div>' +
                    '<div class="form-value width-2x" v-if="isJson">' +
                    '<el-input :disabled="disabled" type="textarea" :autosize="{ minRows: 7, maxRows: 8 }" v-model="JSON.decode(jsonData).message"></el-input>' +
                    '</div>' +
                    '<div class="form-value width-2x" v-else>' +
                    '<el-input :disabled="disabled" type="textarea" :autosize="{ minRows: 7, maxRows: 8 }" v-model="jsonData"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        jsonData: row.data || '',
                        isJson: (row.data || '').startsWith('{') && (row.data || '').endsWith('}'),
                        txt: null,
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                            let selfDlg = this;
                            selfDlg.txt = row.txt;
                        }
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/msg/MerchantMsg.vue